import { Link, useNavigate } from "react-router-dom";
import React, { useState } from 'react';


import "../../assets/css/grid.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import logo from '../../assets/images/logo.png';
import * as authApis from 'apis/auth';


function LoginPage() {

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [expiry, setExpiry] = useState(null);
  const [notice, setNotice] = useState('');






  // Function to handle input changes
  const handleChange = async(e) => {
    const { name, value } = e.target;
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
    setExpiry(null);
    setNotice('');
  };

  // Function to handle form submission
  const handleSubmit = async(e) => {
    e.preventDefault();

    // Example validation: check if email and password are not empty
    if (!email || !password) {
      setError( "Please enter the credentials" );
      return;
    }

    // Reset error if credentials are provided
    setError(false);
    setExpiry(null);
    setNotice('');
    
    try {
      const response = await authApis.login({ email, password });
      const { token } = response.data;

      if (token) {
        localStorage.setItem('token', token);
        if (response.data.role) {
          localStorage.setItem('role', response.data.role);
        }
        if (response.data.role === 'partner') {
          navigate('/partner/verify');
          return;
        }
        const redirectTo = sessionStorage.getItem('postLoginRedirect');
        if (redirectTo) {
          sessionStorage.removeItem('postLoginRedirect');
          navigate(redirectTo);
        } else {
          navigate('/dashboard');
        }
      }
    } catch (err) {
      const data = err.response?.data;
      // The password was right and only the membership has lapsed, so offer a
      // way back in rather than a validation error. The renewal token travels
      // in router state, not the URL, so it stays out of history and logs.
      if (data?.code === 'SUBSCRIPTION_EXPIRED') {
        setExpiry({
          message: data.message,
          expiredOn: data.expiredOn,
          renewalToken: data.renewalToken,
        });
      } else if (data?.code === 'SUBSCRIPTION_PAYMENT_PENDING') {
        // A retry is still running, so there is nothing for them to do here
        // except wait. No renew button: buying a second mandate now could
        // charge them twice.
        setNotice(data.message);
      } else if (err.response && err.response.status === 401) {
        setError('Invalid email or password');
      } else {
        setError('An unexpected error occurred. Please try again later.');
      }
    }
    
    
   

  
  };
  return (
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
          <img  src={logo} alt="" />
          </div>
          <div className="login-title">
            <h1>Welcome back !</h1>
            <h6>Log in to your account</h6>
          </div>
          <form className="login-form" onSubmit={handleSubmit}>
      <div className="login-input">
        <label htmlFor="email">Email address</label>
        <input
          type="text"
          placeholder="Email address"
          required
          name="email"
          value={email}
          onChange={handleChange}
        />
      </div>

      <div className="login-input">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          placeholder="Password"
          required
          name="password"
          value={password}
          onChange={handleChange}
        />
      </div>
      {notice && (
        <div className="login-notice">
          <p>{notice}</p>
        </div>
      )}

      {expiry && (
        <div className="login-renew">
          <p>{expiry.message}</p>
          <button
            type="button"
            onClick={() =>
              navigate('/renew', {
                state: {
                  renewalToken: expiry.renewalToken,
                  expiredOn: expiry.expiredOn,
                  email,
                },
              })
            }
          >
            Renew membership
          </button>
        </div>
      )}

      {error && (
        <div className="errors">
          <h1>{error}</h1>
        </div>
      )}

      <div className="login-footer">
        <h6>
          <Link to="/Forgotpassword">Forgot password?</Link>
        </h6>
      </div>
      <div className="login-input">
        <button type="submit">Sign In</button>
      </div>
    </form>

       
          <div className="login-footer">
            <p>Don't have an account  <a >  <Link to="/Plans#plans">Signup Now!</Link></a></p>

          </div>

        </div>
      </div>

      
    </div>
  );
}

export default LoginPage;